import React from "react"
import MetaTags from "react-meta-tags"
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Form,
  Modal,
  Input,
  Button,
} from "reactstrap"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import * as Yup from "yup"
import CustomInput from "Custom/CustomInput"
import { Field, FormikProvider, useFormik, ErrorMessage } from "formik"
import CustomSelect from "Custom/CustomSelect"
import CustomFlatpickr from "Custom/CustomFlatpicker"
import { useState } from "react"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Link } from "react-router-dom"
import { Spin } from "antd"
import swal from "sweetalert"
import moment from "moment"

import { get, post, postFormData } from "helpers/api_helper"
import {
  GET_PackageSoItemList,
  GET_soNumberListFoAddPackageAndShipment,
  ADD_Carrier,
  GET_CarrierList,
  GET_OrganisationDetail,
  GET_ShipmentPreference,
  POST_CreateShipment,
  POST_UploadDocumnet,
  POST_DIRECT_SHIPMENT,
  //GET_UserCompanyInfo,
} from "helpers/url_helper"
import SwalError from "Custom/SwalError"
import { useSelector } from "react-redux"

const DirectShipmentAdd = props => {
  const navigate = useNavigate()
  const [mode, setMode] = useState(0)
  const [shipmentNoModal, setShipmentModal] = useState(false)
  const [sONoOptions, setSONoOptions] = useState([])
  //const [packageNoOptions, setPackageNoOptions] = useState([])
  const [carrierOptions, setCarrierOptions] = useState([])

  const [shipmentPreferenceOption, setShipmentPreferenceOption] = useState([])

  const [isLoading, setIsLoading] = useState(false)

  const [showSwalError, setShowSwalError] = useState(false)
  const [swalErrorMsg, setSwalErrorMsg] = useState("")

  const [salesOrderID, setSalesOrderID] = useState(0)

  const [selectedCarrier, setSelectedCarrier] = useState(null)
  const [showNewInput, setShowNewInput] = useState(false)
  const [newCarrierName, setNewCarrierName] = useState("")

  const companyid = useSelector(state => state?.Login?.currentCompanyId)
  const AuthUser = JSON.parse(localStorage.getItem("authUser"))
  const userCompanyInfo = JSON.parse(localStorage.getItem("userCompanyInfo"))
  let Cid = AuthUser?.org === true ? userCompanyInfo?.organization?.id : companyid

  const initialFileUpload = {
    File: "",
  }
  const validationSchema = Yup.object().shape({
    SalesOrderNumber: Yup.string().required(
      "Sales Order Number is a required field."
    ),

    ShipmentOrder: Yup.string().required("Shipment Order is a required field."),
    ShipmentDate: Yup.string().required("Shipment Date is a required field."),
    Carrier: Yup.string().required("Carrier is required field."),
    InvoiceCopy: Yup.array()
    .of(
      Yup.object().shape({
        File: Yup.mixed().required("Invoice Copy is required"),
      })
    )
    .min(1, "Invoice Copy is required"),
    // Notes: Yup.string().required("Notes is required field."),
  })

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CustomerName: userCompanyInfo?.organization?.display_name,
      SalesOrderNumber: "",
      ShipmentOrder: "",
      ShipmentDate: "",
      Notes: "",
      Carrier: "",
      TrackingURL: "",
      TrackingNo: "",
      ShippingCharges: "",
      ShipmentPreference: "",
      BillLandingNo: "",
      ContainerNumber: "",
      ShipmentStatus: "",
      OrganisationID: userCompanyInfo?.organization?.id,
      ListOffileUpload: [initialFileUpload],
      InvoiceCopy: [initialFileUpload],
      ContactID: Cid,
    },
    validateOnBlur: false,
    ListOfItemDetail: null,
  })

  const {
    setValues,
    setFieldValue,
    values: {
      ListOffileUpload,
      // ContactID,
      SalesOrderNumber,
      ListOfItemDetail,
    },
  } = formik

  // const getFileUploadValidationCheck = (e, index) => {
  //   var pattern = /(\.|\/)(xls|xlsx|doc|docx|pdf|jpg|jpeg|csv|xml)$/i;

  //   if (e.target.files?.length > 0) {
  //     if (!pattern.test(e.target.files[0]?.name)) {
  //       e.target.value = [];
  //       swal("", "Only XLS, XLSX, DOC, DOCX, PDF, JPG, CSV, and XML files are allowed!", "warning");
  //     } else {
  //       formik.setFieldValue(`ListOffileUpload[${index}].File`, e.target.files[0]);
  //     }
  //   }
  // }

  const getFileUploadValidationCheck = (e, index) => {
    // Define allowed file types (regex pattern for various file types)
    const pattern = /(\.|\/)(xls|xlsx|doc|docx|pdf|jpg|jpeg|csv|xml)$/i;
  
    if (e.target.files?.length > 0) {
      const selectedFile = e.target.files[0];
  
      // Fetch max file size from .env file (default to 5MB if not set)
      const maxFileSizeMB = parseFloat(process.env.REACT_APP_IMAGE_SIZE_LIMIT) || 2; // Default to 5MB
  
      // Convert file size to MB
      const fileSizeInMB = Math.round(selectedFile.size / 1024 / 1024); // Convert bytes to MB
  
      // Check if file size exceeds the allowed limit
      if (fileSizeInMB > maxFileSizeMB) {
        e.target.value = null;  // Clear the input
        swal("Attach File(s)", `You can upload file upto ${maxFileSizeMB}MB size!`, "warning");
        return;  // Stop further processing
      }
  
      // Check if file type is allowed
      if (!pattern.test(selectedFile.name)) {
        e.target.value = null;  // Clear the input
        swal("", "Only XLS, XLSX, DOC, DOCX, PDF, JPG, CSV, and XML files are allowed!", "warning");
      } else {
        // If the file is valid, update the form state
        formik.setFieldValue(`ListOffileUpload[${index}].File`, selectedFile);
      }
    }
  };
  

  // const getFileUploadValidationCheckForInvoice = e => {
    
  //   var pattern = /(\.|\/)(xls|xlsx|doc|docx|pdf|jpg|jpeg|csv|xml)$/i;

  //   if (e.target.files?.length > 0) {
  //     if (!pattern.test(e.target.files[0]?.name)) {
  //       e.target.value = [];
  //       swal("", "Only XLS, XLSX, DOC, DOCX, PDF, JPG, CSV, and XML files are allowed!", "warning");
  //     } else {
  //       setFieldValue("InvoiceCopy.[0].File", e.target.files[0])
  //     }
  //   }
  // }

  const getFileUploadValidationCheckForInvoice = e => {
    // Define allowed file types (regex pattern for various file types)
    const pattern = /(\.|\/)(xls|xlsx|doc|docx|pdf|jpg|jpeg|csv|xml)$/i;
  
    if (e.target.files?.length > 0) {
      const selectedFile = e.target.files[0];
  
      // Fetch max file size from .env file (default to 5MB if not set)
      const maxFileSizeMB = parseFloat(process.env.REACT_APP_IMAGE_SIZE_LIMIT) || 2; // Default to 5MB
  
      // Convert file size to MB
      const fileSizeInMB = Math.round(selectedFile.size / 1024 / 1024); // Convert bytes to MB
  
      // Check if file size exceeds the allowed limit
      if (fileSizeInMB > maxFileSizeMB) {
        e.target.value = null;  // Clear the input
        swal("Attach File(s)", `You can upload file upto ${maxFileSizeMB}MB size!`, "warning");
        return;  // Stop further processing
      }
  
      // Check if file type is allowed
      if (!pattern.test(selectedFile.name)) {
        e.target.value = null;  // Clear the input
        swal("", "Only XLS, XLSX, DOC, DOCX, PDF, JPG, CSV, and XML files are allowed!", "warning");
      } else {
        // If the file is valid, update the field value in the form
        setFieldValue("InvoiceCopy.[0].File", selectedFile);
      }
    }
  };
  

  const handleValidSubmit = async values => {
    setIsLoading(true)

    let AttachFileIDs = []

    await Promise.all(
      values.ListOffileUpload?.map(async x => {
        if (x?.File) {
          let formData = new FormData()
          //alert(x.File)
          formData.append("module_slug", "org-purchase-vendor-shipment")
          formData.append("label", "Attach File(s) to Shipment")
          formData.append("file", x.File)
          setIsLoading(true)
          await postFormData(POST_UploadDocumnet, formData)
            .then(response => {
              if (response?.status === 200) {
                AttachFileIDs.push(response?.data?.id)
                setIsLoading(false)
              } else {
                // swal("Error!", response?.message?.file, "error")
                if (typeof response?.message == "string") {
                  swal({
                    title: "Error!",
                    text: response.message,
                    icon: "error",
                    button: "OK",
                  })
                } else {
                  setSwalErrorMsg(response?.message)
                  setShowSwalError(true)
                }
                setIsLoading(false)
              }
            })
            .catch(error => {
              console.log(error)
              setIsLoading(false)
            })
        }
      })
    )
    // }

    await Promise.all(
      values.InvoiceCopy?.map(async x => {
        if (x?.File) {
          //console.log("file 1", x?.File)
          let formData = new FormData()
          //alert(x.File)
          formData.append("module_slug", "org-purchase-vendor-shipment")
          formData.append("label", "Invoice")
          formData.append("file", x.File)
          setIsLoading(true)
          await postFormData(POST_UploadDocumnet, formData)
            .then(response => {
              //  console.log("file", response)
              if (response?.status === 200) {
                AttachFileIDs.push(response?.data?.id)
                setIsLoading(false)
              } else {
                // swal("Error!", response?.message?.file, "error")
                if (typeof response?.message == "string") {
                  swal({
                    title: "Error!",
                    text: response.message,
                    icon: "error",
                    button: "OK",
                  })
                } else {
                  setSwalErrorMsg(response?.message)
                  setShowSwalError(true)
                }
                setIsLoading(false)
              }
            })
            .catch(error => {
              console.log(error)
              setIsLoading(false)
            })
        }
      })
    )

    setIsLoading(true)
    const payload = {
      organization_id: 1,
      so_id: salesOrderID,
      shipment_number: values.ShipmentOrder,
      shipment_date:
        `${moment(values.ShipmentDate).format("YYYY-MM-DD")}` +
        " " +
        moment(new Date()).format("h:mm:ss"),
      tracking_url: values.TrackingURL,
      tracking_no: values.TrackingNo,
      shipment_carrier: values.Carrier,
      shipment_type: values.ShipmentPreference,
      bill_of_landing_no: values.BillLandingNo,
      container_no: values.ContainerNumber,
      shipping_line: values.Notes,
      status: "shipped",
      file_id: AttachFileIDs,
      shipping_charges: values.ShippingCharges,
      notes: values.Notes,
      package_details: values.ListOfItemDetail.map((p) => { return { purchase_order_items_id: p.id, quantity_packed: p.QuantitytoPack } })
    }

    return post(POST_DIRECT_SHIPMENT, payload)
      .then(response => {
        if (response.status === 200) {
          swal({
            title: "Success",
            text: response?.message,
            icon: "success",
            button: "OK",
          })
          setIsLoading(false)
          setTimeout(() => {
            navigate("/direct-shipment")
          }, 1000)
        } else {
          if (typeof response?.message == "string") {
            swal({
              title: "Error!",
              text: response.message,
              icon: "error",
              button: "OK",
            })
          } else {
            setSwalErrorMsg(response?.message)
            setShowSwalError(true)
          }
          setIsLoading(false)
        }
      })
      .catch(error => {
        console.log(error)
        setIsLoading(false)
      })
  }

  const packageSoItemList = soID => {
    if (soID) {
      setIsLoading(true)
      get(GET_PackageSoItemList + "?so_id=" + soID)
        .then(res => {
          //console.log("PackageSoItemList", res)
          if (res?.data?.length > 0 && res.status === 200) {
            const itemDetails = res?.data?.map(item => ({
              id: item.id,
              QuantitytoPack: "",
              Ordered: item.quantity,
              Unit: item.unit.unit_name,
              Packed: item.quantity_packed,
              ItemName: item.product.product_name,
            }))
            formik.setFieldValue("ListOfItemDetail", itemDetails)
          } else {
            formik.setFieldValue("ListOfItemDetail", null)
            setIsLoading(false)
            //console.log("Unexpected Status Error", res.status)
          }
        })
        .catch(error => {
          console.log("Error", error)
        })
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      formik.setFieldValue("ListOfItemDetail", null)
    }
  }

  useEffect(() => {
    getSOList()
    getCarrierOptionList()
    getShipmentReference()
  }, [])

  useEffect(() => {
    if (SalesOrderNumber) {
      setMode(1)
    } else {
      setMode(0)
    }
  }, [SalesOrderNumber])

  const getShipmentReference = () => {
    setIsLoading(true)
    get(GET_ShipmentPreference).then(res => {
      if (res) {
        const valuesArray = res.data.shipment_preference
        var NewArrayOption = Object.entries(valuesArray)

        let NewOption = []
        NewArrayOption.map(x =>
          NewOption.push({
            label: x[1],
            value: x[0],
          })
        )

        setShipmentPreferenceOption(NewOption)
      }
    })
    setIsLoading(false)
  }

  const getSOList = () => {
    setIsLoading(true)

    get(GET_soNumberListFoAddPackageAndShipment + "?contact_id=" + Cid).then(
      res => {
        if (res?.data?.length > 0) {
          let NewOptions = []

          res?.data?.filter(status=> status?.so_status === "accepted")?.map(item =>
            NewOptions.push({
              label: item.sales_order_no,
              value: item.id,
            })
          )
          setSONoOptions(NewOptions)
        }
      }
    )
    setIsLoading(false)
  }

  
  const handleSelectChange = option => {
    setSelectedCarrier(option.value)
    if (option.value === "other") {
      setShowNewInput(option?.value === "other")
    } else {
      setShowNewInput(false)
      formik.setFieldValue("Carrier", option.value) // Sync with Formik
    }
  }

  const getCarrierOptionList = () => {
    setIsLoading(true);
  
    get(GET_CarrierList)
      .then(res => {
        if (res?.data?.carrier !== "") {
          if (Array.isArray(res?.data)) {
            const list = res.data.map(item => ({
              label: item.name,
              value: item.value,
            }));
            list.push({ label: "Other", value: "other" }); // Add "Other" at end
  
            setCarrierOptions(list);
          }
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
 
  const handleNewCarrierSubmit = () => {
    if (!newCarrierName.trim()) return

    post(ADD_Carrier, { name: newCarrierName }).then(res => {
      if (res?.success == true) {
        getCarrierOptionList()
        setShowNewInput(false)
        formik.setFieldValue("Carrier", res?.carrier?.value)
      } else {
        alert("Failed to add carrier")
      }
    })
  }

  const initialListofShipmentNumber = {
    Prefix: "",
    NextNumber: "",
    Default: false,
    AddManually: true,
  }

  const validationSchemaShipmentNo = Yup.object().shape({})

  const formikShipmentNo = useFormik({
    validationSchema: validationSchemaShipmentNo,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitShipmentNo(values, formikHelpers),
    initialValues: {
      Setting: false,
      AddManually: true,
      ListofShipmentNumber: [initialListofShipmentNumber],
    },
    validateOnBlur: false,
  })

  const {
    values: { Setting, ListofShipmentNumber, AddManually },
  } = formikShipmentNo

  const handleValidSubmitShipmentNo = values => {
    setShipmentModal(false)
  }

  const delete_ShipmentNumber = index => {
    formikShipmentNo.setFieldValue(
      "ListofShipmentNumber",
      ListofShipmentNumber.filter((element, i) => i !== index)
    )
  }

  const AddShipmentNumber = () => {
    formikShipmentNo.setFieldValue("ListofShipmentNumber", [
      ...ListofShipmentNumber,
      {
        Prefix: "",
        NextNumber: "",
        Default: false,
      },
    ])
  }

  const delete_FileUpload = index => {
    formik.setFieldValue(
      "ListOffileUpload",
      ListOffileUpload.filter((element, i) => i !== index)
    )
  }

  const AddFileUpload = () => {
    formik.setFieldValue("ListOffileUpload", [
      ...ListOffileUpload,
      {
        File: "",
      },
    ])
  }

  return (
    <React.Fragment>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <div className="page-content">
          <MetaTags>
            <title>{"Add Direct Shipment"} | Katlax OMS</title>
          </MetaTags>

          <Container fluid>
            <Row className="mt-3">
              <Col lg={6}>
                <div className="mt-2" style={{ fontSize: "large" }}>
                  <b>Add Direct Shipment</b>
                </div>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <FormikProvider value={formik}>
                      <Form onSubmit={formik.handleSubmit}>
                        <Row className="mt-3">
                          <Col lg={2}>
                            <div className="mt-2" style={{ color: "#000000" }}>
                              Organization Name
                            </div>
                          </Col>
                          <Col lg={5}>
                            <Field
                              name="CustomerName"
                              placeholder={"Organization Name"}
                              component={CustomInput}
                              maxLength={50}
                              // value={organisationName}
                              readOnly
                            />
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={2}>
                            <div className="mt-2" style={{ color: "#000000" }}>
                            Katlax PO No.{" "}
                              <span className="text-danger">*</span>
                            </div>
                          </Col>
                          <Col lg={5}>
                            <Field
                              name="SalesOrderNumber"
                              placeholder={"Select Katlax PO No. "}
                              component={CustomSelect}
                              options={sONoOptions}
                              onChange={e => {
                                packageSoItemList(e?.value)
                                setSalesOrderID(e?.value)
                                formik.setFieldValue(
                                  "SalesOrderNumber",
                                  e?.value
                                )
                              }}
                            />
                          </Col>
                        </Row>
                        {mode === 1 ? (
                          <>
                            <hr></hr>
                            <Row>
                              <Col lg={12}>
                                <div className="table-responsive">
                                  <table className="table table-bordered mb-0">
                                    <thead>
                                      <tr className="table-light">
                                        <th style={{ minWidth: "300px" }}>
                                          ITEMS & DESCRIPTION
                                        </th>
                                        <th style={{ minWidth: "100px" }}>
                                          ORDERED
                                        </th>
                                        <th style={{ minWidth: "200px" }}>
                                          UNIT
                                        </th>
                                        <th style={{ minWidth: "100px" }}>
                                          PACKED
                                        </th>
                                        <th style={{ minWidth: "200px" }}>
                                          QUANTITY TO PACK
                                        </th>

                                        {/* <th
                                          style={{
                                            borderBlockColor: "#ffffff00",
                                            borderColor: "#ffffff00",
                                            backgroundColor: "#ffffff00",
                                          }}
                                        ></th> */}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {ListOfItemDetail ? (
                                        ListOfItemDetail &&
                                        ListOfItemDetail.map(
                                          (itemdetail, index) => (
                                            <tr key={index}>
                                              <td>{itemdetail.ItemName}</td>
                                              <td>{itemdetail.Ordered}</td>
                                              <td>{itemdetail.Unit}</td>
                                              <td>{itemdetail.Packed}</td>
                                              <td>
                                                <Field
                                                  type="number"
                                                  name={`ListOfItemDetail.[${index}].QuantitytoPack`}
                                                  placeholder="Quantity to Pack"
                                                  component={CustomInput}
                                                  validate={(value) => {
                                                    const max = itemdetail.Ordered - itemdetail.Packed;
                                                    if (value > max) {
                                                      return `Value cannot be more than ${max}`;
                                                    }
                                                    if (value < 0) {
                                                      return 'Value cannot be less than 0';
                                                    }
                                                    return undefined;
                                                  }}
                                                />
                                                 
                                              </td>
                                            </tr>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td colSpan={6}>
                                            No matching records found
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          ""
                        )}
                        <hr></hr>

                        <Row>
                          <Col lg={2} style={{ color: "#000000" }}>
                            Shipment Order#{" "}
                            <span className="text-danger">*</span>
                          </Col>
                          <Col lg={4}>
                            <div className="d-flex">
                              <Field
                                type="text"
                                name="ShipmentOrder"
                                placeholder={"Enter Shipment Order"}
                                component={CustomInput}
                                maxLength={50}
                              />
                              &nbsp; &nbsp;
                              <Link
                                onClick={() => {
                                  setShipmentModal(true)
                                }}
                                className="mt-2"
                                title="Edit"
                              >
                                <i className="ti-settings"></i>
                              </Link>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={2}>
                            <div className="mt-2" style={{ color: "#000000" }}>
                              Shipment Date{" "}
                              <span className="text-danger">*</span>
                            </div>
                          </Col>
                          <Col lg={4}>
                            <Field
                              name={"ShipmentDate"}
                              placeholder={"dd/mm/yyyy"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "d/m/Y",
                                dateFormat: "d/m/Y",
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={2} style={{ color: "#000000" }}>
                            Carrier <span className="text-danger">*</span>
                          </Col>
                          <Col lg={4}>
                          <Field
                            type="text"
                            name="Carrier"
                            placeholder={"Select Carrier"}
                            component={CustomSelect}
                            onChange={handleSelectChange}
                            options={carrierOptions}
                            value={selectedCarrier}
                          />

                            {showNewInput && (
                            <div style={{ marginTop: "10px", marginBottom: "10px", display: "flex", alignItems: "center", gap: "10px" }}>
                              <Input
                                type="text"
                                placeholder="Enter new carrier name"
                                value={newCarrierName}
                                onChange={e => setNewCarrierName(e.target.value)}
                              />
                              <Button color="primary" onClick={handleNewCarrierSubmit}>
                                Add
                              </Button>
                            </div>
                          )}
                          </Col>

                          <Col lg={2} style={{ color: "#000000" }}>
                            Tracking No#
                          </Col>
                          <Col lg={4}>
                            <Field
                              type="text"
                              name="TrackingNo"
                              placeholder={"Enter Tracking Number"}
                              component={CustomInput}
                              maxLength={50}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={2} style={{ color: "#000000" }}>
                            Tracking URL
                          </Col>
                          <Col lg={4}>
                            <Field
                              type="text"
                              name="TrackingURL"
                              placeholder={"Enter Tracking URL"}
                              component={CustomInput}
                              maxLength={50}
                            />
                          </Col>
                          <Col lg={2} style={{ color: "#000000" }}>
                            Bill of Lading No
                          </Col>
                          <Col lg={4}>
                            <Field
                              type="text"
                              name="BillLandingNo"
                              placeholder={"Enter Bill of Lading No"}
                              component={CustomInput}
                              maxLength={50}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={2} style={{ color: "#000000" }}>
                            {"Shipping Charges (If Any)"}
                          </Col>
                          <Col lg={4}>
                            <Field
                              type="number"
                              name="ShippingCharges"
                              placeholder={"Enter Shipping Charges"}
                              component={CustomInput}
                              min={0}
                            />
                          </Col>
                          <Col lg={2} style={{ color: "#000000" }}>
                            Container Number
                          </Col>
                          <Col lg={4}>
                            <Field
                              type="text"
                              name="ContainerNumber"
                              placeholder={"Enter  Container Number"}
                              component={CustomInput}
                              maxLength={50}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={2}>
                            <div className="mt-2" style={{ color: "#000000" }}>
                            Shipment Mode
                            </div>
                          </Col>
                          <Col lg={4}>
                            <Field
                              name="ShipmentPreference"
                              placeholder={"Select Shipment Mode"}
                              component={CustomSelect}
                              options={shipmentPreferenceOption}
                            />
                          </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                          <Col lg={6}>
                            <Row>
                              <Col lg={12} style={{ color: "#000000" }}>
                                {"Attach File(s) to Shipment"}
                              </Col>

                              {ListOffileUpload?.map((files, index) => (
                                <Col lg={9} className="mt-2">
                                  <div className="d-flex">
                                    <input
                                      type="file"
                                      id={`ListOffileUpload.[${index}].File`}
                                      name={`ListOffileUpload.[${index}].File`}
                                      className="form-control"
                                      onChange={e => {
                                        getFileUploadValidationCheck(e, index)
                                      }}
                                    />{" "}
                                    &nbsp;
                                    <i
                                      className="fas fa-times-circle"
                                      style={{
                                        color: "red",
                                        marginTop: "12px",
                                      }}
                                      onClick={() => {
                                        delete_FileUpload(index)
                                      }}
                                    ></i>
                                  </div>
                                </Col>
                              ))}

                              <Col lg={12} className="mt-2">
                                <button
                                  className="btn btn-secondary"
                                  type="button"
                                  onClick={() => {
                                    AddFileUpload()
                                  }}
                                >
                                  <i
                                    className="fas fa-plus-circle"
                                    style={{ color: "dodgerblue" }}
                                  ></i>
                                  &nbsp; Add More
                                </button>
                              </Col>
                            </Row>
                            <Row className="mt-3">
                              <Col lg={12} style={{ color: "#000000" }}>
                                Invoice Copy &nbsp;
                              </Col>

                              <Col lg={9} className="mt-2">
                                <div className="d-flex">
                                  <input
                                    type="file"
                                    id="InvoiceCopy[0].File"
                                    name="InvoiceCopy[0].File"
                                    className={`form-control ${
                                      formik.touched.InvoiceCopy &&
                                      formik.errors.InvoiceCopy &&
                                      formik.errors.InvoiceCopy[0]?.File
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    onChange={e => {
                                      const file = e.target.files[0];
                                      setFieldValue("InvoiceCopy[0].File", file);
                                      getFileUploadValidationCheckForInvoice(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                </div>
                                {formik.touched.InvoiceCopy &&
                                  formik.errors.InvoiceCopy &&
                                  formik.errors.InvoiceCopy[0]?.File && (
                                    <div className="invalid-feedback d-block">
                                      {formik.errors.InvoiceCopy[0]?.File}
                                    </div>
                                  )}
                              </Col>
                            </Row>

                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Notes"
                              type="textarea"
                              name="Notes"
                              placeholder={"Enter Notes"}
                              component={CustomInput}
                              // required
                            />
                          </Col>
                        </Row>

                        <hr></hr>
                        <Row>
                          <Col lg={6}>
                            <button className="btn btn-primary" type="submit">
                              Send
                            </button>
                            &nbsp;&nbsp;
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => {
                                navigate("/shipment")
                              }}
                            >
                              Cancel
                            </button>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <SwalError
              showError={showSwalError}
              setShowError={setShowSwalError}
              ErrorMsg={swalErrorMsg}
            ></SwalError>
          </Container>
        </div>
        <Modal isOpen={shipmentNoModal} centered={true} size="lg">
          <div className="modal-header mdl_header">
            <h5 className="modal-title mt-0">{"Shipment Number"}</h5>
            <button
              type="button"
              className="btn close mt-2"
              onClick={() => setShipmentModal(false)}
            >
              <span>×</span>
            </button>
          </div>
          <div className="modal-body">
            <FormikProvider value={formikShipmentNo}>
              <Form onSubmit={formikShipmentNo.handleSubmit}>
                <Row className="mt-3">
                  <Col lg={12}>
                    Your shipment number are set on auto-generate mode to save
                    your time. Are you sure about changing this setting
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col lg={12}>
                    <Input
                      type="radio"
                      name="Setting"
                      id="Setting"
                      className="form-check-input"
                      onChange={e => {
                        // console.log(e.target.checked)
                        formikShipmentNo.setFieldValue(
                          "Setting",
                          e?.target.value
                        )
                        formikShipmentNo.setFieldValue("AddManually", false)
                      }}
                      checked={Setting}
                    />
                    &nbsp;
                    <label className="custom-control-label" htmlFor="Setting">
                      Continue auto-generating shipment number
                    </label>
                  </Col>
                </Row>
                {Setting ? (
                  <>
                    <div className="table-responsive mt-3">
                      <table className="table table-bordered mb-0">
                        <thead>
                          <tr className="table-light">
                            <th style={{ minWidth: "200px" }}>Prefix</th>
                            <th style={{ minWidth: "200px" }}>Next Number</th>
                            <th style={{ minWidth: "50px" }}>Default</th>
                            <th style={{ minWidth: "80px" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListofShipmentNumber &&
                            ListofShipmentNumber.map(
                              (shipmentNumber, index) => (
                                <tr>
                                  <td>
                                    <Field
                                      type="text"
                                      name={`ListofShipmentNumber.[${index}].Prefix`}
                                      placeholder={"Prefix"}
                                      component={CustomInput}
                                      style={{ textTransform: "Uppercase" }}
                                    />
                                  </td>
                                  <td>
                                    <Field
                                      type="number"
                                      name={`ListofShipmentNumber.[${index}].NextNumber`}
                                      placeholder={"Next Number"}
                                      component={CustomInput}
                                    />
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <Input
                                      type="radio"
                                      name={`ListofShipmentNumber.[${index}].Default`}
                                      id={`ListofShipmentNumber.[${index}].Default`}
                                      className="form-check-input"
                                      onChange={e => {
                                        formikShipmentNo.setFieldValue(
                                          `ListofShipmentNumber.[${index}].Default`,
                                          e?.target.checked
                                        )
                                      }}
                                      checked={shipmentNumber.Default}
                                    />
                                  </td>
                                  <td>
                                    <div className="d-flex">
                                      <Button
                                        className="btn btn-secondary waves-effect waves-light btn btn-secondary"
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                          padding: "0px",
                                        }}
                                        onClick={() => { }}
                                        title="Edit"
                                      >
                                        <i
                                          className="fas fa-edit"
                                          style={{ color: "#17a98c" }}
                                        ></i>
                                      </Button>
                                      &nbsp;
                                      <Button
                                        className="btn btn-secondary waves-effect waves-light btn btn-secondary"
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                          padding: "0px",
                                        }}
                                        title="Delete"
                                        onClick={() => {
                                          delete_ShipmentNumber(index)
                                        }}
                                      >
                                        <i
                                          className="fas fa-trash-alt"
                                          style={{
                                            color: "red",
                                          }}
                                        ></i>
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              )
                            )}
                        </tbody>
                      </table>
                    </div>
                    <Row className="mt-2">
                      <Col style={{ textAlign: "end" }}>
                        <button
                          className="btn btn-secondary"
                          type="button"
                          onClick={() => {
                            AddShipmentNumber()
                          }}
                        >
                          <i
                            className="fas fa-plus-circle"
                            style={{ color: "dodgerblue" }}
                          ></i>
                          &nbsp; Add More
                        </button>{" "}
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}
                <Row className="mt-3">
                  <Col lg={12}>
                    <Input
                      type="radio"
                      name="AddManually"
                      id="AddManually"
                      className="form-check-input"
                      onChange={e => {
                        formikShipmentNo.setFieldValue(
                          "AddManually",
                          e?.target.value
                        )
                        formikShipmentNo.setFieldValue("Setting", false)
                      }}
                      checked={AddManually}
                    />
                    &nbsp;
                    <label
                      className="custom-control-label"
                      htmlFor="AddManually"
                    >
                      I will add them manually each time
                    </label>
                  </Col>
                </Row>
                <hr></hr>
                <Row className="mt-3">
                  <Col lg={12} style={{ textAlign: "right" }}>
                    <button className="btn btn-primary" type="submit">
                      Save
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        setShipmentModal(false)
                      }}
                    >
                      Cancel
                    </button>
                  </Col>
                </Row>
              </Form>
            </FormikProvider>
          </div>
        </Modal>
      </Spin>
    </React.Fragment>
  )
}
DirectShipmentAdd.propTypes = {
  t: PropTypes.any,
}
export default withRouter(withTranslation()(DirectShipmentAdd))
